import { createSelector } from 'reselect';
import { RootState } from '..';
import { FamilyUserRolesState } from './types';

export const rootSelector: (state: RootState) => FamilyUserRolesState = (state: RootState) => state.familyUserRoles;

export const familyUserRolesSelector = createSelector(rootSelector, (items) => items.familyUserRoles);
export const familyUserRoleSelector = (roleId: string) =>
  createSelector(rootSelector, (items) => items.familyUserRoles.find((role) => role._id === roleId));
